import React from "react";
import styled from "@emotion/styled";
import moment, { Moment } from "moment";
import TextField from "@mui/material/TextField";

import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";

const Container = styled.div`
  min-width: 240px;
  max-width: 250px;
`;

const StyledTextField = styled(TextField)`
  width: 100%;

  .MuiInput-input {
    cursor: pointer;
  }
`;

type Props = {
  disabled?: boolean;
  inputFormat?: string;
  label?: string;
  shouldDisableDate?: (day: any) => boolean;
  onChange: (value: any, keyboardInputValue?: string | undefined) => void;
  value: string;
};

function DateTimePicker({
  disabled,
  inputFormat,
  label,
  onChange,
  shouldDisableDate,
  value,
}: Props): JSX.Element {
  function handleDateChange(value: Moment | null): void {
    const now = moment();
    let date;

    if (!value) {
      date = now;
    } else {
      date = now < value ? now : value;
    }

    return onChange(date);
  }

  return (
    <Container>
      <MobileDateTimePicker
        toolbarTitle=""
        closeOnSelect={true}
        inputFormat={inputFormat}
        disabled={disabled}
        shouldDisableDate={shouldDisableDate}
        label={label}
        value={value}
        onAccept={handleDateChange}
        renderInput={(params) => (
          <StyledTextField {...params} variant="standard" />
        )}
        onChange={() => {}}
      />
    </Container>
  );
}

DateTimePicker.defaultProps = {
  inputFormat: "dddd D MMMM - LT",
};

export default DateTimePicker;
